import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 页面组件化
 */
const frontEndDIYComponent = {

  /**
   * 查询自定义页面组件组
   */
  getFrontEndDIYComponentGroups () {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYComponentGroups, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 查询自定义页面组件
   */
  getFrontEndDIYComponent (groupId) {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYComponent, utils.postParamsArrayToJsonString({ groupId }))
  },
  /**
   * 查询自定义页面组件
   */
  getFrontEndDIYComponent2 () {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYComponent2, utils.postParamsArrayToJsonString({}))
  },
  /**
   * 创建自定义页面
   */
  createFrontEndDIYPage (name, content, companyId) {
    return axios.post(base.frontEndDIYComponent.createFrontEndDIYPage, utils.postParamsArrayToJsonString({ name, content, companyId }))
  },
  /**
   * 修改自定义页面显示名称
   */
  modifyFrontEndDIYPageName (id, name) {
    return axios.post(base.frontEndDIYComponent.modifyFrontEndDIYPageName, utils.postParamsArrayToJsonString({ id, name }))
  },
  /**
   * 修改自定义页面内容
   */
  modifyFrontEndDIYPageContent (id, thumbnail, content) {
    return axios.post(base.frontEndDIYComponent.modifyFrontEndDIYPageContent, utils.postParamsArrayToJsonString({ id, thumbnail, content }))
  },
  /**
   * 获取自定义页面
   */
  getFrontEndDIYPages (ids) {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYPages, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 获取自定义页面内容
   */
  getFrontEndDIYPageContent (id) {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYPageContent, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 获取自定义页面内容
   */
  getFrontEndDIYPageContent2 (ids) {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYPageContent2, utils.postParamsArrayToJsonString({ ids }))
  },
  /**
   * 删除自定义页面
   */
  deleteFrontEndDIYPage (id) {
    return axios.post(base.frontEndDIYComponent.deleteFrontEndDIYPage, utils.postParamsArrayToJsonString({ id }))
  },
  /**
   * 复制自定义页面
   */
  copyFrontEndDIYPages (ids) {
    return axios.post(base.frontEndDIYComponent.copyFrontEndDIYPages, utils.postParamsArrayToJsonString({ ids }))
  },
  getFrontEndDIYPages2 (companyId) {
    return axios.post(base.frontEndDIYComponent.getFrontEndDIYPages2, utils.postParamsArrayToJsonString({ companyId }))
  },
}

export default frontEndDIYComponent